module.exports = __webpack_public_path__ + "img/6b398198de5677ba72a59075a82972f4.png";